import { getData } from "../../api/api";
import { GetMessageUrl } from "../../config";
import {
  REQUEST_ROOMS_PENDING,
  REQUEST_ROOMS_SUCCESS,
  REQUEST_ROOMS_FAILED,
  SET_ROOM,
  RECEIVE_ROOM,
} from "./actionTypes";

export const setRoom = (room) => ({ type: SET_ROOM, payload: room });

export const requestRooms =
  (clientId = "", apotheekId = "") =>
  (dispatch) => {
    const baseUrl = GetMessageUrl() + "/api/chatroom";
    const url = clientId ? `${baseUrl}?clientId=${clientId}` : `${baseUrl}?ovisApotheekId=${apotheekId}`;

    dispatch({ type: REQUEST_ROOMS_PENDING });
    getData(url)
      .then((data) => dispatch({ type: REQUEST_ROOMS_SUCCESS, payload: data }))
      .catch((error) => dispatch({ type: REQUEST_ROOMS_FAILED, payload: error }));
  };

export function receiveRoom(name = "", id = null, pharmacyname = "", tehuisgroepname = "", newMessagesCount = null) {
  return {
    type: RECEIVE_ROOM,
    payload: {
      room: {
        id,
        name,
        pharmacyname,
        tehuisgroepname,
        newMessagesCount,
      },
    },
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/roomActions.js